import { getInboxFilterDocument } from '@griply/utils';
import { useMemo } from 'react';
import { useUser } from 'shared/hooks/use-user';

export const useInboxFilterDocument = () => {
  const user = useUser();
  const inboxFilters = user?.settings?.filters?.inbox;

  return useMemo(() => getInboxFilterDocument(inboxFilters), [inboxFilters]);
};
